<template>
  <div class="filesystem">
    <!-- Path bar -->
    <div class="filesystem__path">
      <span v-html="path" />
    </div>
    <filesystem-list :objects="filesystem" :opened="true" :parent-path="''" />
  </div>
</template>

<script>
import FilesystemList from '@/components/FilesystemList';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'filesystem',
  components: {
    FilesystemList,
  },
  data() {
    return {
      filesystem: [],
    };
  },
  computed: {
    ...mapState({
      path: state => state.filesystem.path,
      objects: state => state.filesystem.objects,
    }),
    selected() {
      return this.getSelected(this.filesystem);
    },
  },
  created() {
    this.$store.dispatch('breadcrumbs/reset');
    this.$store.dispatch('filesystem/load');
  },
  watch: {
    objects: {
      handler(value) {
        this.filesystem = _.cloneDeep(value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$path-padding-vertical: 6px;
$path-padding-horizontal: 20px;
$path-height: 24px;
.filesystem__path {
  height: $path-height + 2 * $path-padding-vertical;
  line-height: $path-height;
  padding-left: $path-padding-horizontal;
  padding-right: $path-padding-horizontal;
  padding-top: $path-padding-vertical;
  padding-bottom: $path-padding-vertical;
  border: 1px solid #eee;
  font-size: 80%;
  &:before {
    content: '/';
    display: inline;
  }
}
</style>

<docs>
# Filesystem

## Usage

```
const filesystem = require('extensions/filesystem');
```

## Methods

### filesystem.upload(body, filepath[, callback, bucket, acl])

Upload file or stream to filepath

```
filesystem.upload(doc, 'assets/pdf/test.pdf', data => {
  console.log(data);
});
```

### filesystem.ifNotExists(path[, callback, bucket])

Run callback if file does not exists

```
filesystem.ifNotExists('assets/pdf/test.pdf', () => {
  // Do something if file does not exist
});
```

### filesystem.ifExists(path[, callback, bucket])

Run callback if file exists

```
filesystem.ifExists('assets/pdf/test.pdf', () => {
  // Do something if file exists
});
```

### async filesystem.exists(path[, bucket])

Check if file exists

```
filesystem.exists('assets/pdf/test.pdf');
```

### filesystem.list([callback, bucket, token])

List of all keys (files) in bucket

```
filesystem.list(data => {
    console.log(data);
});
```

### filesystem.tree(objects)

Transform list of all keys to tree structure

```
filesystem.list(data => {
  console.log(filesystem.tree(data));
});
```

### filesystem.getSignedUrl(object[, callback, bucket])

Returns url of object. Lookup uses `object.Key` as Key so make sure you have defined that.

```
filesystem.getSignedUrl({
  Key: 'object-key'
}, url => {
  console.log(url);
});
```

### filesystem.create(path, name, callback, bucket)

Create object of `name` in specified `path`

```
filesystem.create('/path/to/', 'folder/', data => {
  console.log(data);
});
```

### filesystem.remove(object[, callback, bucket])

Remove object from storage. `object.Key` as Key so make sure you have defined that.

```
filesystem.remove({
  Key: 'object-key'
}, data => {
  console.log(data);
});
```
</docs>
